import Table from "Shared/components/DataTable/Table"
import restClient from 'Shared/hooks/restClient'

const DashboardsDatatable = ({ tableType }) => {
  const handleTableClick = (e) => {
    if(e.target.classList.contains('restore-dashboard')) {
      const dashboardId = e.target.dataset.dashboardId
      
      if (window.confirm('Are you sure you want to restore this dashboard?')) {
        restClient.post(`/api/dashboards/${dashboardId}/restore`).then(() => {
          window.location.href = '/admin/dashboards'
        })
      }
    }
  }

  const emptyTableMessage = tableType === 'all' ? "You've not set up any dashboards yet." : "You have no archived dashboards."

  const tableProps = {
    table: 'dashboards',
    scope: { section: 'dashboards' },
    language: { emptyTable: emptyTableMessage },
    includeTypeParam: true,
    onClick: handleTableClick,
  }

  return (
    <div className="section">
      <div className="box">
        <div className="header">
          <h2>Your dashboards</h2>
        </div>

        <Table {...tableProps} />
      </div>
    </div>
  )
}

export default DashboardsDatatable
